import withdrawalConstants from '../constants/withdrawal-constants';
import constants from '../../../../common/constants';

export const validate = (formValues, props) => {
  const errors = {};

  const balance = props.userBalance ? parseFloat(props.userBalance.balance) : 0;

  const userId = props && props.profile && props.profile.user_id;
  // for QA team so they can test withdrawal with Ben's account on prod
  const minWithdrawalAmount = constants.is_prod_env && withdrawalConstants.bensUserIdProd === userId ? 1 : withdrawalConstants.min_withdrawal_amount;

  if (balance <= 0 || (formValues[withdrawalConstants.fields.amount] && balance < parseFloat(formValues[withdrawalConstants.fields.amount]))) {
    errors[withdrawalConstants.fields.amount] = 'WITHDRAWALS.AMOUNT_NOT_ENOUGH_FUNDS';
  }

  if (!formValues[withdrawalConstants.fields.amount]) {
    errors[withdrawalConstants.fields.amount] = 'WITHDRAWALS.AMOUNT_REQUIRED';
  }

  if (formValues[withdrawalConstants.fields.amount] && parseFloat(formValues[withdrawalConstants.fields.amount]) < parseFloat(minWithdrawalAmount)) {
    errors[withdrawalConstants.fields.amount] = 'WITHDRAWALS.MIN_AMOUNT';
  }

  if (!formValues[withdrawalConstants.fields.payment_method_id]) {
    errors[withdrawalConstants.fields.payment_method_id] = 'WITHDRAWALS.PAYMENT_METHOD_REQUIRED';
  }

  return errors;
};



// WEBPACK FOOTER //
// ./src/app/main/withdrawals/validators/withdrawal-validators.js